<template>
  <div>
    <loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>

    <form class="ml-3 mt-3 mr-3 mb-3">
      <div class="col-md-12">
        <a-steps :current="current" size="small">
          <a-step
            v-for="item in steps"
            :key="item.title"
            :title="item.title"
          />
        </a-steps>

        <!-- STEP 0: DADOS BÁSICOS -->
        <div class="row d-flex justify-content-center mt-3" v-if="current == 0">
        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">

            <label for="inputTitulo">
            Nome
            <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
            </el-tooltip>
            </label>
            <div class="input-group">
            <div class="input-group-prepend mb-2">
                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
            </div>
            <input
                id="inputTitulo"
                maxlength="500"
                tabindex="1"
                type="text"
                class="form-control mb-2"
                v-model="projeto.titulo"
                placeholder="Informe o nome do projeto"
            />
            </div>

            <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label for="inputData">
                Período
                <el-tooltip content="Campo obrigatório" placement="top">
                    <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                </el-tooltip>
                </label>
                <div class="input-group">
                <div class="input-group-prepend mb-2">
                    <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                </div>
                <flat-picker
                    value=""
                    tabindex="2"
                    id="dataInicio"
                    @blur="selecionarDataFim()"
                    class="form-control datepicker mb-2"
                    placeholder="Data de Início"
                    v-model="projeto.dataInicio"
                    :config="{
                    allowInput: true,
                    dateFormat: 'd/m/Y',
                    altFormat: 'M j, Y',
                    }"
                />
                <span class="m-2">até</span>
                <div class="input-group-prepend mb-2">
                    <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                </div>
                <flat-picker
                    value=""
                    id="dataFim"
                    tabindex="3"
                    class="form-control datepicker mb-2"
                    placeholder="Data fim"
                    v-model="projeto.dataFim"
                    :config="{
                    allowInput: true,
                    minDate: projeto.dataInicio,
                    dateFormat: 'd/m/Y',
                    altFormat: 'M j, Y',
                    }"
                />
                </div>
            </div>
            </div>

            <div class="row">
            <div class="col">
                <label for="inputDescricao">
                Classificação
                <el-tooltip content="Campo obrigatório" placement="top">
                    <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                </el-tooltip>
                </label>
                <div class="input-group">
                <div class="input-group-prepend mb-2">
                    <span class="input-group-text"><i class="far fa-bookmark mr-1"></i></span>
                </div>
                <select class="form-control mb-2" tabindex="4" id="classificacao" v-model="projeto.classificacao">
                    <option value="">Selecione</option>
                    <option v-for="c in listaClassificacao" :key="c.codigo" :value="c">
                    {{ c.descricao }}
                    </option>
                </select>
                </div>
            </div>
            <div class="col">
                <label for="inputRelevancia">
                Relevância
                <el-tooltip content="Campo obrigatório" placement="top">
                    <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                </el-tooltip>
                </label>
                <div class="input-group">
                <div class="input-group-prepend mb-2">
                    <span class="input-group-text"><i class="far fa-star"></i></span>
                </div>
                <select tabindex="5" class="form-control mb-2" id="relevancia" v-model="projeto.relevancia">
                    <option value="">Selecione</option>
                    <option v-for="r in listaRelevancia" :key="r.codigo" :value="r">
                    {{ r.descricao }}
                    </option>
                </select>
                </div>
            </div>
            </div>
        </div>
        </div>

        <!-- ABA DE GT -->
        <div class="row d-flex justify-content-center mt-3" v-if="current == 1">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-8">
            <label for="inputMeusGT">
              Grupo(s) de Trabalho para o Projeto:<br />&nbsp; - {{ projeto.titulo }}
              <el-tooltip content="Ao menos um Grupo de Trabalho é necessário" placement="top">
                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <div class="mt-1" style="background-color: WhiteSmoke">
              <div class="row ml-4" v-for="gt in projeto.listaGT" :key="gt.idgt">
                <div class="col-10 mt-1 mb-2">
                  {{ gt.coordenacao.sigla }} - {{ gt.nome }}
                </div>
                <div class="col-1 text-center">
                  <el-tooltip style="cursor: pointer" content="Retirar Grupo de Trabalho" placement="top">
                    <i class="fas fa-trash mt-2 text-danger" @click="retirarGT(gt.idgt)"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <br />
            <div class="text-center">
              <el-tooltip content="Adicionar um Grupo de Trabalho ao projeto" placement="top">
                <button type="button" tabindex="9" class="btn btn-primary" @click="addGrupoTrabalho()">
                  <span><i class="fas fa-plus-circle mr-2"></i>Adicionar</span>
                </button>
              </el-tooltip>
              <br /><br />
            </div>
          </div>
        </div>

        <!-- ABA DE RESPONSÁVEIS -->
        <div class="row d-flex justify-content-center mt-3" v-if="current == 2">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-8">
            <label for="inputMeusGT">
              Responsável(is) pelo Projeto:<br />&nbsp; - {{ projeto.titulo }}
              <el-tooltip content="Ao menos um responsável é necessário" placement="top">
                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <div class="mt-1" style="background-color: WhiteSmoke">
              <div class="row ml-4" v-for="usuario in projeto.listaResp" :key="usuario.idusuario">
                <div class="col-10 mt-1 mb-2">
                  {{ usuario.nome }} ({{ usuario.apelido }})
                </div>
                <div class="col-1 text-center">
                  <el-tooltip style="cursor: pointer" content="Retirar Responsável" placement="top">
                    <i class="fas fa-trash mt-2 text-danger" @click="retirarResp(usuario.idusuario)"></i>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <br />
            <div class="text-center">
              <el-tooltip content="Adicionar um Responsável ao projeto" placement="top">
                <button type="button" tabindex="9" class="btn btn-primary" @click="addResponsavel()">
                  <span><i class="fas fa-plus-circle mr-2"></i>Adicionar</span>
                </button>
              </el-tooltip>
              <br /><br />
            </div>
          </div>
        </div>

        <!-- ABA DE OKRs -->
        <div class="row d-flex justify-content-center mt-3" v-if="current == 3">
          <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12">
            <label>
              OKR(s) vinculado(s) ao Projeto:<br />&nbsp; - {{ projeto.titulo }}
              <el-tooltip content="Campo opcional. O projeto pode ser vinculado a nenhum, um ou vários OKRs" placement="top">
                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <div class="mt-1" style="background-color: WhiteSmoke">
              <div class="row ml-4" v-for="okr in projeto.listaOkr" :key="okr.idokr">
                <div class="col-10 mt-1 mb-2">
                  {{ addMascaraCodigoOkr(okr.idokr) }} - {{ okr.descricao }}
                </div>
                <div class="col-1 text-center">
                  <el-tooltip style="cursor: pointer" content="Retirar OKR" placement="top">
                    <i class="fas fa-trash mt-2 text-danger" @click="retirarOkr(okr.idokr)"></i>
                  </el-tooltip>
                </div>
              </div>
              <div v-if="!projeto.listaOkr || projeto.listaOkr.length == 0" class="p-3 text-muted text-center">
                Nenhum objetivo vinculado.
              </div>
            </div>
            <br />
            <div class="text-center">
              <el-tooltip content="Vincular um OKR ao projeto" placement="top">
                <button type="button" class="btn btn-primary" @click="addOkr()">
                  <span><i class="fas fa-plus-circle mr-2"></i>Adicionar Okr</span>
                </button>
              </el-tooltip>
              <br /><br />
            </div>
          </div>
        </div>

        <!-- ABA DE RESUMO -->
        <div class="row d-flex justify-content-center mt-3" v-if="current == 4">
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12">
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Nome:</div>
              <div class="col-lg-6 text-left">{{ projeto.titulo }}</div>
            </div>
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Período:</div>
              <div class="col-lg-6 text-left">{{ projeto.dataInicio }} até {{ projeto.dataFim }}</div>
            </div>
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Classificação:</div>
              <div class="col-lg-6 text-left">{{ classificacao }}</div>
            </div>
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Relevância:</div>
              <div class="col-lg-6 text-left">{{ relevancia }}</div>
            </div>
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Grupo(s) de Trabalho:</div>
              <div class="col-lg-6 text-left">
                <div v-for="gt in projeto.listaGT" :key="gt.idgt">{{ gt.nome }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Responsável(is):</div>
              <div class="col-lg-6 text-left">
                <div v-for="resp in projeto.listaResp" :key="resp.idusuario">{{ resp.nome }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 font-weight-bold text-right">Okr(s):</div>
              <div class="col-lg-6 text-left">
                <div v-for="okr in projeto.listaOkr" :key="okr.idokr">
                  {{ addMascaraCodigoOkr(okr.idokr) }} - {{ okr.descricao }}
                </div>
                <span v-if="!projeto.listaOkr || projeto.listaOkr.length == 0" class="text-muted">
                  Nenhum objetivo vinculado
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="steps-action w-100 text-center n">

          <el-tooltip style="margin-left: 8px" content="Passo anterior" placement="top" v-if="current > 0">
            <span>
              <button type="button" class="btn btn-info" @click="anterior">
                <i class="fas fa-angle-double-left"></i> Anterior
              </button>
            </span>
          </el-tooltip>

          <el-tooltip style="margin-left: 8px" content="Desistir do cadastro do Projeto" placement="top">
            <span>
              <button type="button" tabindex="9" class="btn btn-danger" @click="cancelar()">
                <i class="fa fa-times"></i>
                <span>Cancelar</span>
              </button>
            </span>
          </el-tooltip>

          <el-tooltip style="margin-left: 8px" content="Próximo passo" placement="top" v-if="current < steps.length - 1">
            <span>
              <button tabindex="6" type="button" class="btn btn-info" @click="proximo">
                <i class="fas fa-angle-double-right"></i> Próximo
              </button>
            </span>
          </el-tooltip>

          <el-tooltip
            style="margin-left: 8px"
            content="Salvar os dados do projeto"
            placement="top"
            v-if="current == steps.length - 1">
            <span>
              <button type="button" class="btn btn-success" @click="salvarProjeto()">
                <i class="far fa-calendar-check mr-2"></i>
                <span v-if="!projeto.idprojeto">Cadastrar Projeto</span>
                <span v-if="projeto.idprojeto">Alterar Projeto</span>
              </button>
            </span>
          </el-tooltip>
        </div>
      </div>
    </form>

    <!-- MODAL GT -->
    <modal :show.sync="modals.modalGT">
      <loader object="#df3e46" v-show="progressGT" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Incluir Grupo de Trabalho</h4>
        <div class="row">
          <div class="col-9 input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="addGTNome"
              placeholder="Pesquisar por nome" @keyup="pesquisarGT()" />
          </div>
          <div class="col-3 mt-n2">
            <small>Apenas os meus</small>
            <div class="input-group text-center w-100">
              <div class="custom-switch text-center w-100">
                <input type="checkbox" v-model="apenasMeus" class="custom-control-input" id="check3"
                  @change="alterarMeus()" />
                <label class="custom-control-label" for="check3"></label>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 200px; border: 1px dashed #c0c0c0; overflow: auto">
          <div v-for="gt in listaAddGT" :key="gt.idgt">
            <div class="listaGT gtInfo" @click="adicionarGrupoTrabalho(gt)">
              {{ gt.coordenacao.sigla }} - {{ gt.nome }}
              <i class="fas fa-plus text-muted opcao mr-3"></i>
            </div>
          </div>
        </div>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-danger ml-4" @click="fecharModalGT">Desistir</button>
        </div>
      </form>
    </modal>

    <!-- MODAL RESPONSÁVEL -->
    <modal :show.sync="modals.modalResp">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Incluir Responsável</h4>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control mb-2"
              v-model="addRespNome"
              placeholder="Pesquisar por nome"
              @keyup="pesquisarResp()" />
          </div>
        </div>
        <div style="height: 200px; border: 1px dashed #c0c0c0; overflow: auto">
          <div class="listaGT" v-for="resp in listaAddResp" :key="resp.idusuario">
            <div class="gtInfo" @click="adicionarResp(resp)">
              {{ resp.nome }} ({{ resp.apelido }})
              <i class="fas fa-plus text-muted opcao mr-3"></i>
            </div>
          </div>
        </div>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-danger ml-4" @click="fecharModalResp">Desistir</button>
        </div>
      </form>
    </modal>

    <!-- MODAL OKR -->
    <modal :show.sync="modals.modalOkr" size="lg">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Vincular Okr</h4>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" ref="addOkrNomeInput" class="form-control mb-2"
              v-model="addOkrNome"
              :disabled="progressVinculoOkr"
              placeholder="Pesquisar por nome do OKR"
              @keyup="pesquisarOkr()" />
          </div>
        </div>
        <div style="height: 250px; border: 1px dashed #c0c0c0; overflow: auto">
          <div v-if="progressVinculoOkr" class="text-center text-muted p-3">
            <i class="fas fa-spinner fa-spin mr-1"></i> Pesquisando...
          </div>
          <div v-else-if="addOkrNome.length < 3" class="text-center text-muted p-3">
            <i class="fas fa-search mr-1"></i> Digite ao menos 3 caracteres para pesquisar.
          </div>
          <div v-else-if="listaAddOkr.length === 0" class="text-center text-muted p-3">
            Nenhum Okr encontrado.
          </div>
          <div class="listaGT" v-for="okr in listaAddOkr" :key="okr.idokr">
            <div class="gtInfo" @click="adicionarOkr(okr)" style="align-items: flex-start">
              <span style="flex: 1; word-break: break-word; white-space: normal">
                <strong>{{ addMascaraCodigoOkr(okr.idokr) }}</strong> - {{ okr.descricao }}
                <small class="text-muted ml-1">({{ okr.tipoDescricao }})</small>
              </span>
              <i class="fas fa-plus text-muted opcao mr-3 mt-1" style="flex-shrink: 0"></i>
            </div>
          </div>
        </div>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-secondary ml-4" @click="fecharModalOkr">Fechar</button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  props: {
    idprojeto: {
      type: String,
      default: null,
    },
    modo: {
      type: String,
      default: "página", // 'página' ou 'modal'
    },
  },
  components: {
    flatPicker,
  },
  created() {
    this.carregarTelaProjeto();
  },
  data() {
    return {
      current: 0,
      steps: [
        { title: "Informações do projeto", content: "" },
        { title: "Grupo(s) de trabalho", content: "" },
        { title: "Responsável(is)", content: "" },
        { title: "OKR(s)", content: "" },
        { title: "Resumo", content: "Last-content" },
      ],
      calculoDias: null,
      addGTNome: "",
      addRespNome: "",
      addOkrNome: "",
      apenasMeus: false,
      progress: true,
      progressGT: false,
      progressVinculoOkr: false,
      timeoutOkr: null,
      projeto: {
        titulo: "",
        dataInicio: null,
        dataFim: null,
        dataConclusao: null,
        classificacao: "",
        relevancia: "",
        listaGT: [],
        listaResp: [],
        listaOkr: [],
      },
      classificacao: "",
      relevancia: "",
      listaAddGT: [],
      listaAddGTFiltro: [],
      listaAddResp: [],
      listaAddRespFiltro: [],
      listaAddOkr: [],
      listaAddOkrFiltro: [],
      listaClassificacao: [],
      listaRelevancia: [],
      modals: {
        modalGT: false,
        modalResp: false,
        modalOkr: false,
      },
    };
  },
  methods: {
    carregarTelaProjeto() {
      this.carregarCombosTela();
      if (this.idprojeto) {
        this.carregarProjeto(this.idprojeto);
      } else {
        this.carregarUsuarioAtual();
      }
    },
    cancelar() {
      if (this.modo === 'modal') {
        this.$emit("cancel");
        return;
      }
      const options = {
        title: "Cancelar",
        okLabel: "Confirmar",
        cancelLabel: "Não",
      };
      this.$dialogs.confirm("Deseja realmente desistir do cadastro do projeto?", options)
        .then((res) => {
          if (res.ok) {
            this.$emit("cancel");
          }
        });
    },
    carregarProjeto(idprojeto) {
      this.progress = true;
      this.$clubApi.get("/projeto/" + idprojeto).then((response) => {
        let projeto = response.data.object;
        projeto.listaGT = projeto.listaGrupoTrabalho;
        projeto.listaResp = projeto.listaResponsavel;
        projeto.relevancia = projeto.relevanciaCriador;
        this.projeto = projeto;
        this.projeto.classificacao = { descricao: projeto.classificacaoDescricao, codigo: projeto.classificacao };
        this.projeto.relevancia = { descricao: projeto.relevanciaDescricao, codigo: projeto.relevanciaCriador };
        this.$set(this.projeto, "listaOkr", []);
        this.carregarOkrsVinculados(idprojeto);
      })
      .catch((error) => {
        this.projeto = {
          classificacao: "",
          relevancia: "",
          listaGT: [],
          listaResp: [],
          listaOkr: [],
        };
        this.$toastr.warning(error.response.data.msg);
        setTimeout(() => {
          this.$emit("cancel");
        }, 5000);
      })
      .finally(() => {
        this.progress = false;
      });
    },
    carregarUsuarioAtual() {
      this.$clubApi.get("/user/info").then((response) => {
        let usuario = response.data.object;
        this.projeto.listaGT.push(usuario.grupoTrabalho);
        this.projeto.listaResp.push(usuario);
      }).finally(() => {
        this.progress = false;
      });
    },
    carregarCombosTela() {
      this.$clubApi.get("/enum/classificacao").then((response) => {
        this.listaClassificacao = response.data.object;
      });
      this.$clubApi.get("/enum/relevancia").then((response) => {
        this.listaRelevancia = response.data.object;
      });
    },
    selecionarDataFim() {
      this.projeto.dataFim = this.projeto.dataInicio;
    },
    retirarGT(idgt) {
      this.projeto.listaGT = this.projeto.listaGT.filter((gt) => gt.idgt != idgt);
      this.listaAddResp = [];
      this.listaAddRespFiltro = [];
      this.projeto.listaResp = [];
      // OKRs são filtrados pelo GT, então os vínculos anteriores deixam de ser válidos
      this.$set(this.projeto, "listaOkr", []);
      this.listaAddOkr = [];
      this.listaAddOkrFiltro = [];
      this.$toastr.success("Grupo de Trabalho removido!");
    },
    retirarResp(idusuario) {
      this.projeto.listaResp = this.projeto.listaResp.filter((resp) => resp.idusuario != idusuario);
      this.addRespNome = "";
      this.listaAddResp = [];
      this.$toastr.success("Responsável removido!");
    },
    addGrupoTrabalho() {
      this.addGTNome = "";
      if (this.listaAddGTFiltro.length == 0) {
        this.listaAddGT = [];
        this.progress = true;
        this.$clubApi.get("/estrutura/gt/nome/" + this.apenasMeus).then((response) => {
          this.listaAddGT = response.data.object;
          this.listaAddGTFiltro = response.data.object;
          this.modals.modalGT = true;
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = false;
        });
      } else {
        this.listaAddGT = this.listaAddGTFiltro;
        this.modals.modalGT = true;
      }
    },
    addResponsavel() {
      this.addRespNome = "";
      if (this.listaAddRespFiltro.length == 0) {
        this.listaAddResp = [];
        let objConsulta = { grupoTrabalho: this.projeto.listaGT };
        this.progress = true;
        this.$clubApi.post("/user/nome/", objConsulta).then((response) => {
          this.listaAddResp = response.data.object;
          this.listaAddRespFiltro = response.data.object;
          this.modals.modalResp = true;
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = false;
        });
      } else {
        this.listaAddResp = this.listaAddRespFiltro;
        this.modals.modalResp = true;
      }
    },
    fecharModalGT() {
      this.addGTNome = "";
      this.modals.modalGT = false;
    },
    fecharModalResp() {
      this.addRespNome = "";
      this.listaAddResp = [];
      this.modals.modalResp = false;
    },
    pesquisarGT() {
      if (this.addGTNome == "") {
        this.listaAddGT = this.listaAddGTFiltro;
      } else {
        this.listaAddGT = this.listaAddGTFiltro.filter((gt) => {
          return gt.nome.toUpperCase().indexOf(this.addGTNome.toUpperCase()) >= 0;
        });
      }
    },
    alterarMeus() {
      this.addGTNome = "";
      this.progressGT = true;
      this.$clubApi.get("/estrutura/gt/nome/" + this.apenasMeus).then((response) => {
        this.listaAddGT = response.data.object;
        this.listaAddGTFiltro = response.data.object;
      })
      .catch((error) => {
        this.$toastr.error(error.response.data.msg);
      })
      .finally(() => {
        this.progressGT = false;
      });
    },
    adicionarGrupoTrabalho(gtAdd) {
      let podeAdd = true;
      for (const gt of this.projeto.listaGT) {
        if (gt.idgt === gtAdd.idgt) {
          podeAdd = false;
          break;
        }
      }
      if (podeAdd) {
        this.projeto.listaGT.push(gtAdd);
        this.modals.modalGT = false;
        this.$toastr.success("Grupo de Trabalho adicionado!");
        this.listaAddRespFiltro = [];
      } else {
        this.$toastr.error("Grupo já incluído anteriormente!");
      }
    },
    pesquisarResp() {
      if (this.addRespNome == "") {
        this.listaAddResp = this.listaAddRespFiltro;
      } else {
        this.listaAddResp = this.listaAddRespFiltro.filter((usuario) => {
          return (
            usuario.nome.toUpperCase().indexOf(this.addRespNome.toUpperCase()) >= 0 ||
            usuario.apelido.toUpperCase().indexOf(this.addRespNome.toUpperCase()) >= 0
          );
        });
      }
    },
    adicionarResp(respAdd) {
      let podeAdd = true;
      for (const resp of this.projeto.listaResp) {
        if (resp.idusuario === respAdd.idusuario) {
          podeAdd = false;
          break;
        }
      }
      if (podeAdd) {
        this.projeto.listaResp.push(respAdd);
        this.modals.modalResp = false;
        this.$toastr.success("Responsável adicionado!");
      } else {
        this.$toastr.error("Responsável já adicionado anteriormente.");
      }
    },
    // ---- OKRs ----
    addMascaraCodigoOkr(idokr) {
      return "OKR-" + String(idokr).padStart(3, "0");
    },
    carregarOkrsVinculados(idprojeto) {
      this.$clubApi.get("/okr/projeto/" + idprojeto).then((response) => {
        this.$set(this.projeto, "listaOkr", response.data.object || []);
      })
      .catch(() => {
        this.$toastr.warning("Não foi possível carregar os OKRs vinculados ao projeto.");
      });
    },
    addOkr() {
      if (!this.projeto.listaGT || this.projeto.listaGT.length == 0) {
        this.$toastr.error("Informe pelo menos um grupo de trabalho antes de vincular um OKR!");
        return;
      }
      this.addOkrNome = "";
      this.listaAddOkr = [];
      this.listaAddOkrFiltro = [];
      this.progressVinculoOkr = true;
      this.modals.modalOkr = true;

      const idsGt = this.projeto.listaGT.map((gt) => gt.idgt);
      this.$clubApi.post("/okr/disponiveis", idsGt).then((response) => {
        this.listaAddOkrFiltro = response.data.object || [];
      })
      .catch((error) => {
        this.listaAddOkrFiltro = [];
        this.$toastr.error(error.response && error.response.data ? error.response.data.msg : "Erro ao pesquisar OKRs.");
      })
      .finally(() => {
        this.progressVinculoOkr = false;
        this.$nextTick(() => {
          if (this.$refs.addOkrNomeInput) this.$refs.addOkrNomeInput.focus();
        });
      });
    },
    pesquisarOkr() {
      if (this.timeoutOkr) clearTimeout(this.timeoutOkr);
      if (!this.addOkrNome || this.addOkrNome.length < 3) {
        this.listaAddOkr = [];
        return;
      }
      this.timeoutOkr = setTimeout(() => {
        const filtro = this.addOkrNome.toUpperCase();
        this.listaAddOkr = this.listaAddOkrFiltro.filter((okr) => {
          return (
            (okr.descricao && okr.descricao.toUpperCase().indexOf(filtro) >= 0) ||
            this.addMascaraCodigoOkr(okr.idokr).indexOf(filtro) >= 0
          );
        });
      }, 500);
    },
    adicionarOkr(okrAdd) {
      if (!this.projeto.listaOkr) this.$set(this.projeto, "listaOkr", []);
      const jaVinculado = this.projeto.listaOkr.some((okr) => okr.idokr === okrAdd.idokr);
      if (jaVinculado) {
        this.$toastr.error("Okr já vinculado a esse projeto");
        return;
      }
      this.projeto.listaOkr.push(okrAdd);
      this.$toastr.success("OKR vinculado!");
      this.addOkrNome = "";
      this.listaAddOkr = [];
    },
    retirarOkr(idokr) {
      this.projeto.listaOkr = this.projeto.listaOkr.filter((okr) => okr.idokr !== idokr);
      this.$toastr.success("OKR desvinculado!");
    },
    fecharModalOkr() {
      this.addOkrNome = "";
      this.listaAddOkr = [];
      this.modals.modalOkr = false;
    },
    salvarProjeto() {
      const options = {
        title: "Confirmação",
        okLabel: "Confirmar",
        cancelLabel: "Não",
      };
      let acao = this.projeto.idprojeto ? "alterar" : "incluir";
      let resposta = this.projeto.idprojeto ? "alterado" : "incluído";
      this.$dialogs.confirm('Deseja ' + acao + ' o projeto "' + this.projeto.titulo + '"?', options)
        .then((res) => {
          if (res.ok) {
            this.progress = true;
            this.projeto.classificacao = this.projeto.classificacao.codigo;
            this.projeto.relevancia = this.projeto.relevancia.codigo;
            this.projeto.listaIdOkr = (this.projeto.listaOkr || []).map((okr) => okr.idokr);
            this.$clubApi.post("/projeto", this.projeto).then((response) => {
              this.$toastr.success("Projeto " + resposta + " com sucesso!");
              this.$emit("save", response.data.object);
            })
            .catch((error) => {
              this.progress = false;
              this.$toastr.error(error.response.data.msg);
            });
          }
        });
    },
    proximo() {
      if (this.current == 0) { this.validaInformacoes(); return; }
      if (this.current == 1) { this.validaGrupoTrabalho(); return; }
      if (this.current == 2) { this.validaResponsavel(); return; }
      this.current++;
    },
    anterior() {
      this.current--;
    },
    validaInformacoes() {
      var camposValidos = true;

      if (document.getElementById("relevancia").value == "") {
        this.$toastr.error("Relevância obrigatória!");
        camposValidos = false;
      } else {
        this.relevancia = this.projeto.relevancia.descricao;
      }

      if (document.getElementById("classificacao").value == "") {
        this.$toastr.error("Classificação obrigatória!");
        camposValidos = false;
      } else {
        this.classificacao = this.projeto.classificacao.descricao;
      }

      if (document.getElementById("dataFim").value == "") {
        this.$toastr.error("Data fim obrigatório!");
        camposValidos = false;
      }

      if (document.getElementById("dataInicio").value == "") {
        this.$toastr.error("Data início obrigatório!");
        camposValidos = false;
      }

      if (document.getElementById("inputTitulo").value == "") {
        this.$toastr.error("Nome obrigatório");
        camposValidos = false;
      }

      if (camposValidos) this.current++;
    },
    validaGrupoTrabalho() {
      if (this.projeto.listaGT.length == 0) {
        this.$toastr.error("Informe pelo menos um grupo de trabalho!");
        return;
      }
      this.current++;
    },
    validaResponsavel() {
      if (this.projeto.listaResp.length == 0) {
        this.$toastr.error("Informe pelo menos um responsável!");
        return;
      }
      this.current++;
    },
  },
};
</script>

<style>
.opcao {
  color: #c0c0c0;
  cursor: pointer;
}
.opcao:hover {
  color: red;
  cursor: pointer;
}
.listaGT {
  align-items: center;
  display: flex;
  margin-bottom: 15px;
  padding: 2px;
  height: 40px;
}
.listaGT:hover {
  background-color: #edebfe;
  cursor: pointer;
}
.listaGT:hover .opcao {
  background-color: #edebfe;
  cursor: pointer;
  visibility: visible;
  opacity: 1;
}
.gtInfo {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.steps-content {
  margin-top: 10px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: left;
}
.steps-action {
  margin-top: 24px;
}
</style>
